import { useCustomAppContext } from "contexts/CustomAppContext";
import { useCallback } from "react";

export const useBackstageUrl = () => {
  const { customApp } = useCustomAppContext();
  const base = customApp?.onsiteAppUrl || process.env.REACT_APP_BACKSTAGE_URL;

  const getBackstageUrl = useCallback(
    (path: string) => {
      if (base.startsWith("/")) {
        const url = new URL(`${base}${path}`, window.location.origin);
        return url.toString();
      } else {
        const url = new URL("go", window.location.origin);
        const param = new URL(path, base);
        url.searchParams.set("url", param.toString());
        return url.toString();
      }
    },
    [base],
  );

  const goToBackstageUrl = useCallback(
    (path: string) => {
      window.open(getBackstageUrl(path), "_self");
    },
    [getBackstageUrl],
  );

  return { getBackstageUrl, goToBackstageUrl };
};
